module.exports = __webpack_public_path__ + "static/img/图层 529.2a8b740a.png";